import { AlgPrivacyModalComponent } from './../../dialogs/alg-privacy-modal/alg-privacy-modal.component';
import { AlgPrivacyService } from './../../../services/alg-privacy.service';
import { ModalDialogService } from 'ngx-modal-dialog';
import { AlgAttivazioniService } from './../../../services/alg-attivazioni.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Attivazione, Status, AttivazioneType, LeadSource } from './../../../models/attivazione';
import { Component, OnInit, ViewContainerRef, HostListener } from '@angular/core';
import { UtilsService } from '../../../services/utils.service';
import { map } from 'rxjs/operators';
import { Privacy } from '../../../models/privacy';

@Component({
  selector: 'alg-attivazioni-info',
  templateUrl: './alg-attivazioni-info.component.html',
  styleUrls: ['./alg-attivazioni-info.component.scss']
})
export class AlgAttivazioniInfoComponent implements OnInit {

  public step: any;
  public attivazione: Attivazione;
  public informativeNoteUrl$: Observable<string>;
  public phoneNumber: number;
  public callmeSucces: boolean;
  public recallForm: FormGroup;
  public phone_call: string;
  public callable: boolean = true;
  public callme_privacy: string;
  public fixed: boolean = false;
  public sidebarStyle = { };
  private istanzaGif = '../../assets/images/gif/istanza_1.gif';

  constructor(
    private api: AlgAttivazioniService,
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef,
    private privacySerice: AlgPrivacyService
  ) {
    this.informativeNoteUrl$ = this.privacySerice.onbPrivacyUrl$.pipe(
      map((urls) => urls.informativeNote)
    );
  }

  ngOnInit() {
    this.api.attivazione$.subscribe(attivazione => {
      if(attivazione.webStatus == 'step1') this.callable = true;
      this.step = attivazione.webStatus;
      this.attivazione = attivazione;
      this.phoneNumber = this.attivazione.phone;
      this.callable = true;
    });
    this.recallForm = new FormGroup({
      phone_call: new FormControl(this.phone_call, {
        validators: [Validators.required, Validators.minLength(4), Validators.maxLength(11)]
      })
    });
    // callme privacy text
    let callmeprivacy;
    callmeprivacy = Privacy('accendi');
    this.informativeNoteUrl$.subscribe(e => {
      callmeprivacy.description = callmeprivacy.description.replace('%%LINK%%', e);
      callmeprivacy.description = callmeprivacy.description.replace('<a ', '<a class="privacy-link" ');
      this.callme_privacy = callmeprivacy.description;
    });

    // istanza gif
    this.api.istanzaGif$.subscribe(v => this.istanzaGif = `../../assets/images/gif/istanza_${v}.gif`);
  }

  saveNumber() {
    if(this.recallForm.status === 'VALID'){
      const callMeAttivazione = {...this.attivazione};
      callMeAttivazione.phone = this.phoneNumber;
      callMeAttivazione.opportunityRecallId = callMeAttivazione.opportunityId;
      callMeAttivazione.webStatus = Status.callme;
      callMeAttivazione.typeId = AttivazioneType.callme;
      callMeAttivazione.leadSource = LeadSource.prospect;
      callMeAttivazione.firstname =  callMeAttivazione.firstname ? callMeAttivazione.firstname : 'N/D';
      callMeAttivazione.lastname =  callMeAttivazione.lastname ? callMeAttivazione.lastname : 'N/D';
      this.api.createAttivazione(callMeAttivazione).subscribe((att: Attivazione) =>{
        if (att._id) {
          this.callmeSucces = true;
        }
      });
    } else {
      this.recallForm.get('phone_call').markAsTouched();
      return;
    }
  }

  public onChangeNumber(event) {
    this.phoneNumber = event.target.value;
  }

  openModal(modalContent) {
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: modalContent.title,
      childComponent: AlgPrivacyModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: ' modal-title modal-title-underline'
      },
      data: {
        description: modalContent.description
      }
    });
  }

  public readPrivacy(type) {
    let modalContent;
    modalContent = Privacy('accendi');
    this.informativeNoteUrl$.subscribe(e => {
      modalContent.description = modalContent.description.replace('%%LINK%%', e);
    });
    this.openModal(modalContent || {});
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    let num = window.scrollY;
    let num2 = window.innerHeight;
    // let num3 = this.doc.getElementById('mcl-sidebar').offsetHeight + 80;
    if(num2 >= 700){
      if ( num > 59 ) {
        this.fixed = true;
        this.sidebarStyle = {'top': 20+'px'}
      }else if (this.fixed && num < 60) {
          this.fixed = false;
      }
    }else{
      this.fixed = false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/alg-attivazioni/alg-attivazioni-info/alg-attivazioni-info.component.ts